module.exports = __webpack_public_path__ + "static/media/45.1b480554.jpg";